import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Section from '~/layouts/Section ';
import { Person } from '~/types/Person';
import longdash from '~/constants/longdash';
import Button from '~/components/Button';

interface SignatoryProps {
  onOpen?: () => void;
  readOnly: boolean;
  authorizedSignatoryEmail?: string;
  isCurrentUserAuthorizedSignatory: boolean;
  resultingAuthorizedRepresentative: Person | undefined;
}

const SignatorySection: React.FC<SignatoryProps> = ({
  resultingAuthorizedRepresentative,
  onOpen,
  readOnly,
  authorizedSignatoryEmail,
  isCurrentUserAuthorizedSignatory,
}) => {
  const { t } = useTranslation('contract');

  return (
    <>
      {resultingAuthorizedRepresentative && (
        <Section formItemLast>
          <Typography.Title level={5}>{t('Authorised signatory')}</Typography.Title>
          <Typography.Paragraph>
            {`${resultingAuthorizedRepresentative.firstName} ` +
              `${resultingAuthorizedRepresentative.lastName} ` +
              `(${resultingAuthorizedRepresentative.email}) ` +
              `${longdash} ` +
              `${resultingAuthorizedRepresentative.proof?.designation}`}
          </Typography.Paragraph>
          {!isCurrentUserAuthorizedSignatory && (
            <Typography.Paragraph>
              {t('Your agreement has been sent to the {{email}} address to be signed', {
                email: authorizedSignatoryEmail,
              })}
            </Typography.Paragraph>
          )}
          <Button id="signContract_choosePerson" onClick={onOpen} type="default" size="large" disabled={readOnly}>
            {t('Choose another person')}
          </Button>
        </Section>
      )}
    </>
  );
};

export default SignatorySection;
